// src/supplier/services/supplierApi.js
import { request, ROUTES } from "../../services/api";

const SUPPLIER_SESSION_KEY = "supplier_session";

/** Build headers with supplier portal token */
function supplierHeaders() {
  try {
    const raw = localStorage.getItem(SUPPLIER_SESSION_KEY);
    const session = raw ? JSON.parse(raw) : null;
    if (session?.token) {
      return { Authorization: `Bearer ${session.token}`, "X-Portal": "supplier" };
    }
  } catch { /* ignore */ }
  return {};
}

function sReq(opts) {
  return request({ ...opts, headers: { ...supplierHeaders(), ...opts.headers } });
}

export const supplierAuthAPI = {
  register:    (data) => request({ url: ROUTES.supplierRegister, method: "POST", data }),
  login:       (data) => request({ url: ROUTES.supplierLogin, method: "POST", data }),
  logout:      ()     => request({ url: "/api/auth/logout", method: "POST", headers: { "X-Portal": "supplier" } }),
  verifyEmail: (data) => request({ url: ROUTES.supplierVerifyEmail, method: "POST", data }),
  resendOtp:   (data) => request({ url: ROUTES.supplierResendOtp, method: "POST", data }),
  getMe:       ()     => sReq({ url: ROUTES.supplierMe, method: "GET" }),
};

export const supplierRFQAPI = {
  list:        (params) => sReq({ url: ROUTES.supplierRFQs, method: "GET", params }),
  getById:     (rfqId)  => sReq({ url: ROUTES.supplierRFQById(rfqId), method: "GET" }),
  submitQuote: (rfqId, data) => sReq({ url: ROUTES.supplierSubmitQuote(rfqId), method: "POST", data }),
  decline:     (rfqId, data = {}) => sReq({ url: ROUTES.supplierDeclineRFQ(rfqId), method: "POST", data }),
};

export const supplierPOAPI = {
  list:        (params) => sReq({ url: ROUTES.supplierPOs, method: "GET", params }),
  getById:     (id)     => sReq({ url: ROUTES.supplierPOById(id), method: "GET" }),
  acknowledge: (id)     => sReq({ url: ROUTES.supplierAcknowledgePO(id), method: "POST" }),
  decline:     (id, data = {}) => sReq({ url: ROUTES.supplierDeclinePO(id), method: "POST", data }),
  createDelivery: (id, data) => sReq({ url: ROUTES.supplierCreateDeliveryForPO(id), method: "POST", data }),
};

export const supplierDeliveryAPI = {
  list:   (params) => sReq({ url: ROUTES.supplierDeliveries, method: "GET", params }),
  getById: (id) => sReq({ url: ROUTES.supplierDeliveryById(id), method: "GET" }),
  update: (id, data) => sReq({ url: ROUTES.supplierDeliveryById(id), method: "PATCH", data }),
};

/* ── Notifications ─────────────────────────────────── */
export const supplierNotificationAPI = {
  list:       (params) => sReq({ url: ROUTES.supplierNotifications, method: "GET", params }),
  markRead:   (id)     => sReq({ url: ROUTES.supplierNotificationRead(id), method: "PATCH" }),
  unreadCount: ()      => sReq({ url: ROUTES.supplierUnreadCount, method: "GET" }),
};

/* ── Settings ──────────────────────────────────────── */
export const supplierSettingsAPI = {
  getProfile:    ()       => sReq({ url: ROUTES.supplierSettingsProfile, method: "GET" }),
  updateProfile: (data)   => sReq({ url: ROUTES.supplierSettingsProfile, method: "PATCH", data }),
  getNotificationSettings: () => sReq({ url: ROUTES.supplierSettingsNotifications, method: "GET" }),
  updateNotificationPreferences: (prefs) => sReq({ url: ROUTES.supplierSettingsNotificationPrefs, method: "PATCH", data: { preferences: prefs } }),
  updateNotificationGlobal: (data) => sReq({ url: ROUTES.supplierSettingsNotificationGlobal, method: "PATCH", data }),
};

/* ── Invite Codes ──────────────────────────────────────── */
export const supplierInviteCodeAPI = {
  generate: (data) => sReq({ url: ROUTES.supplierInviteCodes, method: "POST", data }),
  list:     ()     => sReq({ url: ROUTES.supplierInviteCodes, method: "GET" }),
  revoke:   (id)   => sReq({ url: ROUTES.supplierInviteCodeById(id), method: "DELETE" }),
};

/* ── Connected Businesses ──────────────────────────────── */
export const supplierBusinessAPI = {
  list:    (params) => sReq({ url: ROUTES.supplierBusinesses, method: "GET", params }),
  getById: (id)     => sReq({ url: ROUTES.supplierBusinessById(id), method: "GET" }),
};

/* ── Mapped Products ───────────────────────────────────── */
export const supplierProductAPI = {
  list: (params) => sReq({ url: ROUTES.supplierProducts, method: "GET", params }),
};

/* ── Dashboard Summary ─────────────────────────────────── */
export const supplierDashboardAPI = {
  summary: () => sReq({ url: ROUTES.supplierDashboardSummary, method: "GET" }),
};
